import * as React from 'react';
import * as css from './Header.less';

interface HeaderProps {
  address?: string
}

export default class Header extends React.Component<HeaderProps, {}> {
  render() {
    const { address } = this.props;
    return (
      <header className={css.header}>
        <nav>
          <a href="/" />
          <span>Bridge</span>
          <span className={css.sepLine} />
        </nav>
        <span>
          {address || 'Login with Metamask'}
        </span>
      </header>
    );
  }
}
